import { ReactNode } from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IconButtonProps } from 'shared/mui/IconButtons';
import { Tooltip, TooltipProps } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';

import { StyledIconButton } from './TooltipWithInfoIcon.styled';

export type TooltipWithInfoIconProps = {
  tooltipText: ReactNode;
  iconSize?: number;
} & IconButtonProps &
  Pick<TooltipProps, 'componentsProps' | 'placement'>;

export const TooltipWithInfoIcon = ({
  componentsProps,
  tooltipText,
  placement = 'bottom-start',
  ...restProps
}: TooltipWithInfoIconProps): JSX.Element => (
  <StyledIconButton {...restProps}>
    <Tooltip
      arrow
      componentsProps={componentsProps}
      placement={placement}
      sx={{ maxWidth: '247px' }}
      title={<Typography fontSize={12}>{tooltipText}</Typography>}
    >
      <InfoOutlinedIcon color="secondary" />
    </Tooltip>
  </StyledIconButton>
);
